package ui.router

import emotion.react.css
import js.promise.PromiseResult
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import myConst.TestSealed
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.router.RouteObject
import react.router.dom.createBrowserRouter
import remix.run.router.LoaderFunction
import remix.run.router.Router
import ui.pages.ErrorPage
import ui.pages.Page
import ui.showcase.showcases.FindTeacherPage
import ui.showcase.showcases.MainScreen
import ui.showcase.showcases.MorePage
import ui.showcase.showcases.ScheduleChangeScreen
import ui.themePlusContext.useMainContext
import web.cssom.AlignItems
import web.cssom.Display
import web.cssom.JustifyContent
import web.cssom.pct

enum class RouterRoute(
    val route: String,
    val component: FC<Props>,
    val title:String? = null
) {
    ERROR_PAGE(
        route = "__UNDEFINED__",
        component = ErrorPage
    ),
    MAIN_PAGE(
        route = "/",
        component = Page
    ),
    CHANGE_SCHEDULE(
        route = "change-schedule",
        component = ScheduleChangeScreen,
        title = "Изменить расписание"
    ),
    MAIN_SCREEN(
        route = "",
        component = MainScreen,
        title = "Расписание ПРК"
    ),
    MORE_PAGE(
        route = "more",
        component = MorePage,
    ),
    FIND_TEACHER_PAGE(
        route = "find-teacher",
        component = FindTeacherPage,
        title = "Найти преподавателя"
    )
    ;

    val centredElement = FC{
        ReactHTML.div{
            css(className) {
                width = 100.pct
                display = Display.flex
                justifyContent = JustifyContent.center
                alignItems = AlignItems.center
            }
            component()
        }
    }
}


val mainLoader = LoaderFunction<TestSealed> { _, _ ->

    val teastRet = TestSealed.Success("(⊙ˍ⊙)")

    PromiseResult(teastRet)
}

val MyRouter: Router = createBrowserRouter(//tg mini app не работает (или неккоректно работает) с createHashRouter
    routes = arrayOf(
        RouteObject(
            path = RouterRoute.MAIN_PAGE.route,
            Component = RouterRoute.MAIN_PAGE.component,
            ErrorBoundary = RouterRoute.ERROR_PAGE.component,
            HydrateFallback = RouterRoute.ERROR_PAGE.component,
            children = arrayOf(
                RouteObject(
                    path = RouterRoute.MAIN_SCREEN.route,
                    loader = mainLoader,
                    Component = RouterRoute.MAIN_SCREEN.centredElement,
                    ErrorBoundary = RouterRoute.ERROR_PAGE.component,
                ),
                RouteObject(
                    path = RouterRoute.CHANGE_SCHEDULE.route,
                    Component = RouterRoute.CHANGE_SCHEDULE.centredElement,
                    ErrorBoundary = RouterRoute.ERROR_PAGE.component
                ),
                RouteObject(
                    path = RouterRoute.MORE_PAGE.route,
                    Component = RouterRoute.MORE_PAGE.component,
                    ErrorBoundary = RouterRoute.ERROR_PAGE.component
                ),
                RouteObject(
                    path = RouterRoute.FIND_TEACHER_PAGE.route,
                    Component = RouterRoute.FIND_TEACHER_PAGE.component,
                    ErrorBoundary = RouterRoute.ERROR_PAGE.component
                )
            )
        )
    )
)